export default "__VITE_ASSET__DH5K9k1G__"